const INSURANCE_COMPARATOR_REQUEST = "INSURANCE_COMPARATOR_REQUEST";
const INSURANCE_COMPARATOR_SUCCESS = "INSURANCE_COMPARATOR_SUCCESS";
const INSURANCE_COMPARATOR_FAILURE = "INSURANCE_COMPARATOR_FAILURE";

const initialState = {
  fetching: false,
  data: null,
  error: null,
};

const InsuranceComparator = (state = initialState, action) => {
  switch (action.type) {
    case INSURANCE_COMPARATOR_REQUEST:
      return { ...state, fetching: true, error: null };
    case INSURANCE_COMPARATOR_SUCCESS:
      return { ...state, fetching: false, data: action.data };
    case INSURANCE_COMPARATOR_FAILURE:
      return { ...state, fetching: false, data: null, error: action.error };
    default:
      return state;
  }
};

export default InsuranceComparator;
